"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Icon_1 = __importDefault(require("../../Icon"));
var styles_1 = require("./styles");
var MenuItem = function (_a) {
    var isHidden = _a.isHidden, className = _a.className, style = _a.style, icon = _a.icon, label = _a.label, dropdownItems = _a.dropdownItems, isActive = _a.isActive, onClick = _a.onClick, isExpanded = _a.isExpanded, isButton = _a.isButton, isDropdown = _a.isDropdown;
    if (isHidden)
        return null;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var badge = react_1.isValidElement(icon) ? icon : react_1.default.createElement(Icon_1.default, { className: "icon", icon: icon });
    var classNames = (className || '') + " " + (isActive && 'active') + " " + (isButton && 'button') + " " + (isDropdown && 'dropdown');
    var expandedLabel = isExpanded && react_1.default.createElement("span", { className: "label" }, label);
    var dropdownIcon = (isExpanded && isDropdown) && react_1.default.createElement(Icon_1.default, { icon: "dropdown-icon " + (isOpen ? 'up' : 'down') });
    var items = dropdownItems
        && dropdownItems.map(function (item, i) { return (react_1.default.createElement("li", { key: i, className: "dropdown-item " + (item.isActive && 'active'), onClick: item.onClick }, item.label)); });
    var dropdownList = isDropdown
        && react_1.default.createElement(styles_1.StyledList, { className: "dropdown-list " + (isOpen && 'open') }, items);
    var toggleOpen = function () { return setIsOpen(!isOpen); };
    var handleClick = function () {
        if (isDropdown)
            toggleOpen();
        if (onClick && typeof onClick === 'function')
            onClick();
    };
    react_1.useEffect(function () {
        if (isDropdown && !isExpanded)
            setIsOpen(false);
    }, [isExpanded, isDropdown]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.StyledButton, { className: classNames, style: style, onClick: handleClick },
            badge,
            expandedLabel,
            dropdownIcon),
        dropdownList));
};
exports.default = MenuItem;
//# sourceMappingURL=index.js.map